<template>
    <!-- 订单-订单管理 -->
    <div class="container container-tabs sub">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane name="" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane name="new" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">新单( {{ order_number.new }} )</span>
            </el-tab-pane>

            <el-tab-pane name="proceed" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">前往中( {{ order_number.proceed }} )</span>
            </el-tab-pane>

            <el-tab-pane name="serving" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">服务中( {{ order_number.serving }} )</span>
            </el-tab-pane>

            <el-tab-pane name="unpaid" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">未支付( {{ order_number.unpaid }} )</span>
            </el-tab-pane>

            <el-tab-pane name="paid" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">已支付( {{ order_number.paid }} )</span>
            </el-tab-pane>

            <el-tab-pane name="order_cancel" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">已销单( {{ order_number.order_cancel }} )</span>
            </el-tab-pane>
            <el-tab-pane name="early_warning" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">预警( {{ order_number.early_warning }} )</span>
            </el-tab-pane>
            <el-tab-pane name="third_invalid_cancel" class="to-searh" @click="handleClick">
                <span slot="label" class="table-title">三方无效销单( {{ order_number.third_invalid_cancel }} )</span>
            </el-tab-pane>

            <div class="handle-box">
                <div v-show="more_query">
                    <div class="table-head table-head-search">
                        <div>
                            <span class="title">订单号:</span>
                            <el-input v-model="search_data.billno" placeholder="请输入订单号" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>

                        <div>
                            <span class="title">乘客电话:</span>
                            <el-input
                                v-model="search_data.consumer_phone"
                                placeholder="请输入乘客电话"
                                maxlength="11"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div>

                        <!-- <div>
                            <span class="title">乘客姓名:</span>
                            <el-input
                                v-model="search_data.consumer_name"
                                placeholder="请输入乘客姓名"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div> -->
                        <div>
                            <span class="title">系统交易号:</span>

                            <el-input v-model="search_data.pay_no" placeholder="请输入系统交易号" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>

                        <div>
                            <span class="title">起点名称:</span>
                            <el-input v-model="search_data.start_name" placeholder="请输入起点名称" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>
                    </div>

                    <div class="table-head table-head-search">
                        <div>
                            <span class="title">司机电话:</span>
                            <el-input
                                v-model="search_data.driver_phone"
                                placeholder="请输入司机电话"
                                maxlength="11"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div>

                        <div>
                            <span class="title">司机姓名:</span>
                            <el-input v-model="search_data.driver_name" placeholder="请输入司机姓名" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>

                        <div>
                            <span class="title">客服姓名:</span>
                            <el-input v-model="search_data.admin_name" placeholder="请输入客服姓名" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>

                        <div>
                            <span class="title">客服电话:</span>
                            <el-input v-model="search_data.admin_phone" placeholder="请输入客服电话" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>
                    </div>

                    <div class="table-head table-head-search">
                        <div>
                            <span class="title">订单模式:</span>

                            <el-select
                                v-model="value_mode_code"
                                placeholder="请选择模式"
                                @visible-change="modeVisibleChange"
                                @change="modeChange"
                                clearable
                                filterable
                                @keyup.enter.native="searchOrderLists"
                                style="position: relative"
                                :loading="loading"
                            >
                                <el-option
                                    v-for="item in options_mode_code"
                                    :key="item.value"
                                    :label="item.order_mode.name"
                                    :value="item.order_mode.order_mode_code"
                                >
                                </el-option>

                                <el-pagination
                                    class="pagination"
                                    layout="prev, pager, next"
                                    :total="selectPages_data.count"
                                    :page-size="mode_options_data.limit"
                                    @current-change="selectPages_function"
                                    :current-page="mode_options_data.page"
                                />
                            </el-select>
                        </div>

                        <div>
                            <span class="title">新老用户:</span>

                            <el-select
                                v-model="search_data.is_new_visit"
                                placeholder="请选择"
                                clearable
                                @keyup.enter.native="searchOrderLists"
                            >
                                <el-option :label="item.alias" :value="item.val" v-for="(item, index) in is_new_visit_array" :key="index">
                                </el-option>
                            </el-select>
                        </div>

                        <div>
                            <span class="title">回访状态:</span>

                            <el-select
                                v-model="search_data.visit_status"
                                placeholder="请选择状态"
                                clearable
                                @keyup.enter.native="searchOrderLists"
                            >
                                <el-option label="已回访" value="1"> </el-option>
                                <el-option label="未回访" value="0"> </el-option>
                            </el-select>
                        </div>
                        <div>
                            <span class="title">系统编号:</span>
                            <el-input v-model="search_data.order_code" placeholder="请输入系统编号" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div>
                    </div>

                    <div class="table-head table-head-search">
                        <div>
                            <span class="title">集团:</span>

                            <el-select
                                v-model="value_group_code"
                                placeholder="请选择集团"
                                @visible-change="groupList"
                                @change="groupChange"
                                clearable
                                @keyup.enter.native="searchOrderLists"
                                style="position: relative"
                            >
                                <el-option
                                    v-for="item in options_group_code"
                                    :key="item.value"
                                    :label="item.group_name"
                                    :value="item.group_wallet_code"
                                >
                                </el-option>

                                <el-pagination
                                    class="pagination"
                                    layout="prev, pager, next"
                                    :total="selectPages_group_data.count"
                                    :page-size="group_options_data.limit"
                                    @current-change="selectPages_group_function"
                                    :current-page="group_options_data.page"
                                />
                            </el-select>
                        </div>
                        <div>
                            <span class="title">优惠券:</span>

                            <el-select
                                v-model="value_coupon_code"
                                placeholder="请选择优惠券"
                                @visible-change="couponList"
                                @change="couponChange"
                                clearable
                                filterable
                                @keyup.enter.native="searchOrderLists"
                                style="position: relative"
                            >
                                <el-option
                                    v-for="item in options_coupon_code"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.coupon_mode_code"
                                >
                                </el-option>

                                <el-pagination
                                    class="pagination"
                                    layout="prev, pager, next"
                                    :total="selectPages_coupon_data.count"
                                    :page-size="coupon_options_data.limit"
                                    @current-change="selectPages_coupon_function"
                                    :current-page="coupon_options_data.page"
                                />
                            </el-select>
                        </div>
                        <div>
                            <span class="title">订单渠道:</span>

                            <el-select v-model="search_data.order_source" placeholder="请选择渠道" clearable style="position: relative">
                                <el-option :label="item.name" :value="item.order_source" v-for="item in partnerList"> </el-option>
                            </el-select>
                        </div>
                        <div>
                            <span class="title">空驶费:</span>

                            <el-select
                                v-model="search_data.order_consumer_cancel_status"
                                placeholder="请选择渠道"
                                clearable
                                style="position: relative"
                            >
                                <el-option :label="item.remarks" :value="item.type" v-for="item in consunmerCancelStatusList"> </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="table-head table-head-search">
                        <!-- <div>
                            <span class="title">系统交易号:</span>

                            <el-input v-model="search_data.pay_no" placeholder="请输入系统交易号" @keyup.enter.native="searchOrderLists">
                            </el-input>
                        </div> -->

                        <!-- search_data.status == 'order_cancel' tab标签为 已销单 -->
                        <div v-if="search_data.status == 'order_cancel'">
                            <span class="title">销单状态:</span>

                            <el-select
                                v-model="search_data.cancel_status"
                                placeholder="请选择销单状态"
                                clearable
                                style="position: relative"
                            >
                                <el-option label="乘客销单" value="consumer_cancel"> </el-option>
                                <el-option label="司机销单" value="driver_cancel"> </el-option>
                                <el-option label="后台销单" value="admin_cancel"> </el-option>
                            </el-select>
                        </div>

                        <div></div>
                        <div></div>
                    </div>

                    <div class="table-head">
                        <div style="margin: 10px 0" class="search-radio fs-big">
                            <span class="title">订单来源:</span>
                            <el-radio-group v-model="search_data.platform" size="small">
                                <el-radio label="" border> 全部 </el-radio>

                                <el-radio :label="item.val" v-for="(item, index) in platform_select_array" :key="index" border
                                    >{{ item.alias }}
                                </el-radio>
                            </el-radio-group>
                        </div>

                        <div style="margin: 10px 0" class="search-radio fs-big">
                            <span class="title">端口:</span>
                            <el-radio-group v-model="search_data.port" size="small">
                                <el-radio label="" border> 全部 </el-radio>

                                <el-radio :label="item.val" v-for="(item, index) in port_select_array" :key="index" border
                                    >{{ item.alias }}
                                </el-radio>
                            </el-radio-group>
                        </div>

                        <div style="margin: 10px 0; display: flex" class="search-radio fs-big">
                            <div>
                                <span class="title">下单时间:</span>

                                <el-radio-group v-model="order_fixed_time_value" size="small" @change="orderFixedTimeChange">
                                    <el-radio label="" border> 全部 </el-radio>
                                    <el-radio label="today" border>今天 </el-radio>
                                    <el-radio label="yesterday" border>昨天 </el-radio>
                                    <el-radio label="this_week" border>本周 </el-radio>
                                    <el-radio label="last_week" border>上周 </el-radio>
                                    <el-radio label="this_month" border>本月 </el-radio>
                                    <el-radio label="last_month" border>上月 </el-radio>
                                    <el-radio label="between" border>自定义时间 </el-radio>
                                </el-radio-group>
                            </div>

                            <el-date-picker
                                v-if="order_fixed_time_value == 'between'"
                                v-model="order_time_arrway"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="timeChange('order')"
                            >
                            </el-date-picker>
                        </div>

                        <div style="margin: 10px 0; display: flex" class="search-radio fs-big">
                            <div>
                                <span class="title">完成时间:</span>
                                <el-radio-group v-model="complete_fixed_time_value" size="small" @change="completeFixedTimeChange">
                                    <el-radio label="" border> 全部 </el-radio>
                                    <el-radio label="today" border>今天 </el-radio>
                                    <el-radio label="yesterday" border>昨天 </el-radio>
                                    <el-radio label="this_week" border>本周 </el-radio>
                                    <el-radio label="last_week" border>上周 </el-radio>
                                    <el-radio label="this_month" border>本月 </el-radio>
                                    <el-radio label="last_month" border>上月 </el-radio>
                                    <el-radio label="between" border>自定义时间 </el-radio>
                                </el-radio-group>
                            </div>

                            <el-date-picker
                                v-if="complete_fixed_time_value == 'between'"
                                v-model="complete_time_arrway"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="timeChange('complete')"
                            >
                            </el-date-picker>
                        </div>

                        <div style="margin: 10px 0" class="search-radio fs-big">
                            <span class="title">支付通道:</span>
                            <el-radio-group v-model="search_data.pay_channel" size="small">
                                <el-radio label="" border> 全部 </el-radio>
                                <el-radio label="rmb" border>人民币 </el-radio>
                                <el-radio label="wallet" border>钱包支付 </el-radio>
                                <el-radio label="wexinpay" border>微信支付 </el-radio>
                                <el-radio label="alipay" border>支付宝支付 </el-radio>
                                <el-radio label="coin" border>{{ proName }}币 </el-radio>
                            </el-radio-group>
                        </div>

                        <div style="margin: 10px 0" class="search-radio fs-big">
                            <span class="title">用户类型:</span>
                            <el-radio-group v-model="search_data.consumer_vip" size="small">
                                <el-radio label="" border> 全部 </el-radio>
                                <el-radio :label="item.val" v-for="(item, index) in vip_select_array" :key="index" border
                                    >{{ item.alias }}
                                </el-radio>
                            </el-radio-group>
                        </div>

                        <div style="margin: 10px 0" class="search-radio fs-big">
                            <span class="title">订单类型:</span>
                            <el-radio-group v-model="search_data.order_type" size="small">
                                <el-radio label="" border> 全部 </el-radio>
                                <el-radio :label="item.val" v-for="(item, index) in order_type_select" :key="index" border
                                    >{{ item.alias }}
                                </el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>

                <el-row type="flex" justify="space-between">
                    <el-col :span="22">
                        <div v-if="!more_query" style="display: inline-block">
                            <span style="margin-right: 10px">订单号:</span>
                            <el-input v-model="search_data.billno" placeholder="请输入订单号" class="handle-input mr10"> </el-input>
                        </div>
                        <div v-if="!more_query" style="display: inline-block">
                            <span style="margin-right: 10px">乘客电话:</span>
                            <el-input
                                v-model="search_data.consumer_phone"
                                placeholder="请输入乘客电话"
                                maxlength="11"
                                class="handle-input mr10"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div>
                        <div v-if="!more_query" style="display: inline-block">
                            <span style="margin-right: 10px">司机电话:</span>
                            <el-input
                                v-model="search_data.driver_phone"
                                placeholder="请输入司机电话"
                                maxlength="11"
                                class="handle-input mr10"
                                @keyup.enter.native="searchOrderLists"
                            >
                            </el-input>
                        </div>
                        <div style="margin-top: 20px">
                            <el-button type="primary" icon="el-icon-search" @click="searchOrderLists" style="padding: 6px 12px"
                                >搜索
                            </el-button>
                            <el-button icon="el-icon-refresh" @click="refresh" style="padding: 6px 12px">重置 </el-button>
                        </div>
                    </el-col>
                    <el-col :span="2">
                        <el-button @click="getOrderCount" style="padding: 6px 12px" type="success" :loading="btn_loading"
                            >获取订单数量
                        </el-button>
                    </el-col>

                    <el-col :span="2">
                        <el-button type="success" @click="more_query = !more_query" style="padding: 6px 12px">
                            {{ more_query == true ? '普通查询' : '高级查询' }}
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            class="order-table-lists"
            @row-contextmenu="rowContextmenu"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="right" inline class="demo-table-expand">
                        <el-form-item label="订单备注:">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <!-- search_data.status == 'order_cancel' tab标签为 已销单 -->
            <el-table-column label="操作" min-width="110" fixed>
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        trigger="click"
                        @click="orderViewRoute(scope.row.order_code, scope.row.status.val)"
                        v-if="search_data.status != 'order_cancel'"
                    >
                        查看

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="salesOrder(scope.row.order_code)"> 销单 </el-dropdown-item>

                            <!-- v-if="scope.row.status.val == '8'" -->
                            <el-dropdown-item @click.native="modifyPrice(scope.row.order_code, scope.row.amount)">
                                修改订单价格
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    toAppend(
                                        scope.row.order_code,
                                        scope.row.city.name,
                                        scope.row.start_coordinate,
                                        scope.row.order_mode.order_mode_code
                                    )
                                "
                            >
                                追加订单
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="orderPayment(scope.row.order_code, scope.row.amount)"
                                v-if="scope.row.status.val == '7' || scope.row.status.val == '8' || scope.row.status.val == '9'"
                            >
                                订单支付
                            </el-dropdown-item>

                            <el-dropdown-item @click.native="paymentEmptyFare(scope.row.order_code, scope.row.consumer_cancel_amount)">
                                结算空驶费
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    transferOrder(
                                        scope.row.order_code,
                                        scope.row.city.name,
                                        scope.row.start_coordinate,
                                        scope.row.order_mode.order_mode_code
                                    )
                                "
                                v-if="scope.row.status.val == '14' || scope.row.status.val == '0'"
                            >
                                协助指派
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="orderBack(scope.row.order_code, scope.row.status.val)"
                                v-if="
                                    scope.row.status.val == '2' ||
                                    scope.row.status.val == '3' ||
                                    scope.row.status.val == '4' ||
                                    scope.row.status.val == '5' ||
                                    scope.row.status.val == '6'
                                "
                            >
                                订单收回
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="visitOrder(scope.row.order_code, scope.row.visit_status.val, scope.row.consumer_phone)"
                            >
                                订单回访
                            </el-dropdown-item>

                            <el-dropdown-item @click.native="editOrder(scope.row.order_code)"> 订单修改 </el-dropdown-item>

                            <el-dropdown-item @click.native="orderAssess(scope.row.order_code)"> 订单评价 </el-dropdown-item>

                            <el-dropdown-item @click.native="toCoupon(scope.row.order_code)"> 查看订单所用优惠券 </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-button type="primary" @click="orderViewRoute(scope.row.order_code, scope.row.status.val)" v-else>查看 </el-button>
                </template>
            </el-table-column>

            <el-table-column prop="status.alias" label="订单状态" fixed width="110">
                <template slot-scope="scope">
                    <span
                        v-if="scope.row.status.val == 0"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(222, 163, 45, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(222, 163, 45);
                            border: 1px solid rgb(222, 163, 45);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 1"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(130, 85, 159, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(130, 85, 159);
                            border: 1px solid rgb(130, 85, 159);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 2"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(69, 185, 124, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(69, 185, 124);
                            border: 1px solid rgb(69, 185, 124);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 3"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(1, 107, 84, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(1, 107, 84);
                            border: 1px solid rgb(1, 107, 84);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 4"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(253, 175, 23, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(253, 175, 23);
                            border: 1px solid rgb(253, 175, 23);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 5"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(244, 130, 33, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(244, 130, 33);
                            border: 1px solid rgb(244, 130, 33);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 6"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(178, 67, 74, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(178, 67, 74);
                            border: 1px solid rgb(178, 67, 74);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 7"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(250, 167, 84, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(250, 167, 84);
                            border: 1px solid rgb(250, 167, 84);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 8"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(132, 57, 0, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(132, 57, 0);
                            border: 1px solid rgb(132, 57, 0);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 9"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(127, 185, 15, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(127, 185, 15);
                            border: 1px solid rgb(127, 185, 15);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 10"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(170, 34, 22, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(170, 34, 22);
                            border: 1px solid rgb(170, 34, 22);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 11"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(199, 60, 39, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(199, 60, 39);
                            border: 1px solid rgb(199, 60, 39);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 12"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(111, 109, 133, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(111, 109, 133);
                            border: 1px solid rgb(111, 109, 133);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 13"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(0, 138, 143, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(0, 138, 143);
                            border: 1px solid rgb(0, 138, 143);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 14"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(1, 173, 159, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(1, 173, 159);
                            border: 1px solid rgb(1, 173, 159);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 15"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(114, 119, 123, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(114, 119, 123);
                            border: 1px solid rgb(114, 119, 123);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 16"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(244, 112, 74, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(244, 112, 74);
                            border: 1px solid rgb(244, 112, 74);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 17"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(241, 90, 35, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(241, 90, 35);
                            border: 1px solid rgb(241, 90, 35);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 18"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(94, 124, 135, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(94, 124, 135);
                            border: 1px solid rgb(94, 124, 135);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 19"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(61, 55, 69, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(61, 55, 69);
                            border: 1px solid rgb(61, 55, 69);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 20"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(29, 149, 60, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(29, 149, 60);
                            border: 1px solid rgb(29, 149, 60);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>

                    <span
                        v-if="scope.row.status.val == 21"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(29, 149, 60, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(29, 149, 60);
                            border: 1px solid rgb(29, 149, 60);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                    <span
                        v-if="scope.row.status.val == 40"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(89, 19, 60, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(89, 19, 60);
                            border: 1px solid rgb(89, 19, 60);
                        "
                    >
                        {{ scope.row.status.alias }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="order_source" fixed label="订单渠道" min-width="110">
                <template slot-scope="scope">
                    <span
                        v-if="scope.row.order_source != '' && scope.row.order_source != null"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(255, 0, 45, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(255, 90, 45);
                            border: 1px solid rgb(255, 90, 45);
                        "
                    >
                        {{ scope.row.order_source }}</span
                    >
                </template>
            </el-table-column>

            <!-- <el-table-column prop="consumer_phone" label="乘客电话(金色为VIP)" width="180" fixed>
                <template slot-scope="scope">

                    <span :class="{ vip: scope.row.consumer_vip.val == '1', groupName: scope.row.consumer.group_wallet_code != ''}"

                        >{{ scope.row.consumer_phone }}
                        <el-button
                            class="el-icon-search"
                            style="padding: 8px 8px"
                            @click="
                                visitHistory_isShow = !visitHistory_isShow;
                                visitHistory_data = scope.row.order_code;
                            "
                        ></el-button>
                    </span>
                </template>
            </el-table-column> -->
            <!-- 黑色是普通用户，金色是VIP用户，绿色是集团，混色是VIP+集团 -->
            <!-- vip: scope.row.consumer_vip.val == '1'
            groupName: scope.row.consumer.group_wallet_code != ''
            vip + groupName: scope.row.consumer.group_wallet_code != '' && scope.row.consumer_vip.val == '1' -->

            <!--    vip ==1    consumer.group_wallet_code ==' '  是vip 不是集团  前vip 后vip

                    vip ==1    consumer.group_wallet_code !=' '    是vip  是集团  前vip 后groupName

                    vip ==0    consumer.group_wallet_code !=' '    不是vip 是集团  前groupName 后groupName

                    vip ==0    consumer.group_wallet_code ==' '  不是vip 不是集团 前黑色 后黑色 -->

            <el-table-column prop="" fixed label="" min-width="180px">
                <template slot="header">
                    乘客电话
                    <el-popover
                        placement="top-start"
                        title=""
                        width="400"
                        trigger="hover"
                        content="黑色是普通用户，金色是VIP用户，绿色是集团，金色+绿色是“VIP+集团”用户"
                    >
                        <i class="el-icon-question" slot="reference"></i>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <span
                        :class="{
                            vip: scope.row.consumer_vip.val == '1',
                            groupName:
                                scope.row.consumer_vip.val == '0' &&
                                scope.row.consumer.group_wallet_code != '' &&
                                scope.row.consumer.group_wallet_code
                        }"
                        >{{ scope.row.consumer_phone.slice(0, 7) }}</span
                    >
                    <span
                        :class="{
                            vip:
                                scope.row.consumer_vip.val == '1' &&
                                scope.row.consumer.group_wallet_code &&
                                scope.row.consumer.group_wallet_code == '',
                            groupName: scope.row.consumer.group_wallet_code != '' && scope.row.consumer.group_wallet_code
                        }"
                        >{{ scope.row.consumer_phone.slice(7, 11) }}
                    </span>
                    <el-button
                        class="el-icon-search"
                        style="padding: 8px 8px"
                        @click="
                            visitHistory_isShow = !visitHistory_isShow;
                            visitHistory_data = scope.row.order_code;
                        "
                    ></el-button>
                </template>
            </el-table-column>

            <el-table-column prop="order_time.YmdHis" label="下单时间" fixed min-width="130"> </el-table-column>

            <el-table-column label="订单模式" min-width="200">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.order_mode.name" placement="top">
                        <el-button type="text" @click="toIframe(scope.row.order_mode.order_mode_code)" style="font-size: 16px">
                            {{ scope.row.order_mode.name }}
                        </el-button></el-tooltip
                    >
                </template>
            </el-table-column>


            <el-table-column prop="start_name" label="起点名称" min-width="150"> </el-table-column>

            <el-table-column prop="consumer_name" label="乘客姓名" min-width="160">
                <template slot-scope="scope">
                    <span type="text" style="font-size: 16px">
                        {{ scope.row.consumer_name }}

                        <el-button class="el-icon-search" style="padding: 8px 8px" @click="toConsumer(scope.row.consumer_code)"></el-button>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="consumer_name" label="强制大厅" min-width="100">
                <template slot-scope="scope">
                    <span type="text" style="font-size: 16px">
                        <span
                        v-if="scope.row.scan_order.val == 3"
                        style="
                            display: inline-block;
                            height: 100%;
                            line-height: 100%;
                            background-color: rgba(69, 185, 124, 0.2);
                            padding: 5px;
                            border-radius: 5px;
                            color: rgb(69, 185, 124);
                            border: 1px solid rgb(69, 185, 124);
                        "
                        >
                            厅
                        </span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="driver_verify.real_name" label="司机姓名" min-width="160">
                <template slot-scope="scope">
                    <span type="text" style="font-size: 16px" class="img-wrap">
                        <el-image
                            class="sexImg"
                            v-if="scope.row.driver.length !== 0 && scope.row.driver.sex != '2' && scope.row.driver_verify.length !== 0"
                            :src="
                                scope.row.driver.sex == '1' ? require('../../../../assets/nan.png') : require('../../../../assets/nv.png')
                            "
                        ></el-image>
                        <span
                            v-if="scope.row.driver.length !== 0 && scope.row.driver.sex != '2'"
                            :style="scope.row.driver.sex == '1' ? nanStyles : nvStyles"
                            >{{ scope.row.driver_verify == null ? '' : scope.row.driver_verify.real_name }}</span
                        >
                        <span v-else>{{ scope.row.driver_verify == null ? '' : scope.row.driver_verify.real_name }}</span>
                        <!-- {{ scope.row.driver_verify == null ? '' : scope.row.driver_verify.real_name }} -->

                        <el-button
                            class="el-icon-search"
                            style="padding: 8px 8px"
                            @click="toDriver(scope.row.driver_code)"
                            v-if="scope.row.driver_verify.real_name != undefined"
                        ></el-button>
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="driver_phone" label="司机电话" min-width="160"
                ><template slot-scope="scope">
                    <span>
                        <!-- <el-image
                            style="vertical-align: middle"
                            v-if="scope.row.driver.length!==0&&scope.row.driver.sex != '2'&&scope.row.driver_phone!==''"
                            :src="
                                scope.row.driver.sex == '1' ? require('../../../../assets/nan.png') : require('../../../../assets/nv.png')
                            "
                        ></el-image> -->
                        <span
                            v-if="scope.row.driver.length !== 0 && scope.row.driver.sex != '2'"
                            :style="scope.row.driver.sex == '1' ? nanStyles : nvStyles"
                            >{{ scope.row.driver_phone }}</span
                        >
                        <span v-else>{{ scope.row.driver_phone }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="consumer.name" label="下单人姓名" min-width="120"> </el-table-column>

            <!-- <el-table-column prop="" label="下单人电话" width="140">
                <template slot-scope="scope">
                    <div v-if="scope.row.consumer.phone">
                        {{ scope.row.consumer.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}
                    </div>
                </template></el-table-column
            > -->
            <el-table-column prop="consumer.phone" label="下单人电话" min-width="140"> </el-table-column>
            <el-table-column prop="predict_amount" label="预估金额" min-width="80"> </el-table-column>

            <el-table-column prop="amount" label="实际金额" min-width="80"> </el-table-column>

            <el-table-column prop="end_name" label="终点名称" min-width="150"> </el-table-column>

            <el-table-column prop="order_type.alias" label="订单类型" min-width="120"> </el-table-column>
            <el-table-column prop="platform.alias" label="订单来源" min-width="120">
                <template slot-scope="scope">
                    {{ scope.row.platform.alias }}
                </template>
            </el-table-column>

            <el-table-column prop="coupon_name" label="优惠券" min-width="120">
                <template slot-scope="scope">
                    {{ scope.row.coupon_name }}
                </template>
            </el-table-column>

            <el-table-column prop="platform.alias" label="端口" min-width="120">
                <template slot-scope="scope">
                    {{ scope.row.port.alias }}
                </template>
            </el-table-column>

            <el-table-column prop="city.name" label="所属城市" min-width="140">
                <template slot-scope="scope">
                    <el-button type="text" @click="toCity(scope.row.city.city_code)" style="font-size: 16px">
                        {{ scope.row.city.name }}
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column prop="billno" label="订单编号" min-width="200"> </el-table-column>



            <el-table-column prop="visit_status.alias" label="回访状态" min-width="100"> </el-table-column>

            <el-table-column label="新老用户" min-width="100">
                <template slot-scope="scope">
                    {{ scope.row.is_new_visit.alias }}
                </template>
            </el-table-column>

            <el-table-column prop="driver_amount" label="司机实际收到金额" min-width="80"> </el-table-column>
            <el-table-column prop="finish_amount" label="实收金额" min-width="80"> </el-table-column>

            <el-table-column prop="scan_order.alias" label="下单类型" min-width="100"> </el-table-column>

            <el-table-column prop="pay_mode.alias" label="支付方式" min-width="100"> </el-table-column>

            <el-table-column prop="pay_channel.alias" label="付款通道" min-width="100"> </el-table-column>

            <el-table-column label="评价状态" min-width="150">
                <template slot-scope="scope">
                    {{ scope.row.appraise_status == '1' ? '已评价' : '未评价' }}
                </template>
            </el-table-column>

            <el-table-column prop="pay_no" label="系统交易号" min-width="220"> </el-table-column>

            <el-table-column prop="trade_no" label="平台交易号" min-width="220"> </el-table-column>

            <el-table-column prop="reservation_order.YmdHis" label="预约时间" min-width="220"> </el-table-column>

            <el-table-column prop="end_time.YmdHis" label="完成时间" min-width="220"> </el-table-column>

            <el-table-column prop="admin_name" label="服务客服" min-width="180"> </el-table-column>
            <el-table-column prop="consumer_vip.alias" label="乘客类型" min-width="100"> </el-table-column>
            <el-table-column prop="" label="集团用户" width="100">
                <template slot-scope="scope">
                    <div v-if="scope.row.consumer.group_wallet_code">
                        {{ scope.row.consumer.group_wallet_code == '' ? '否' : '是' }}
                    </div>
                    <div v-else>否</div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 查看组件 -->
        <viewRoute :isShow="viewRoute_show" :data="toDispatch_data" :status="order_status" :showConsumer="true"></viewRoute>

        <!-- <toDispatch :isShow="toDispatch_isShow" @onSubmit="orderLists" :data="toDispatch_data"></toDispatch> -->

        <!-- 销单组件 -->
        <salesOrder :isShow="salesOrder_show" @onSubmit="orderLists" :data="toDispatch_data"></salesOrder>

        <el-dialog :visible.sync="iframe_show" width="600px">
            <iframeModel :isShow="iframe_show" :param="iframe_param" :iframe_url="iframe_url" style="height: 60vh"> </iframeModel>

            <div style="text-align: center">
                <el-button @click="iframe_show = false" class="close-btn">关闭 </el-button>
            </div>
        </el-dialog>

        <!-- 编辑司机组件 -->
        <editDriverDrawer :isShow="edit_driver_isShow" :data="driver_code_children"></editDriverDrawer>

        <!-- 编辑乘客组件 -->
        <editConsumer :isShow="edit_consumer_isShow" :data="consumer_code_children" :money="true"></editConsumer>

        <!-- 订单支付组件 -->
        <orderPayment
            :isShow="orderPayment_show"
            :data="orderPayment_data"
            :money="orderPayment_money"
            @onSubmit="orderLists"
        ></orderPayment>
        <!-- 修改订单价格组件 -->
        <modifyPrice :isShow="modifyPrice_show" :data="modifyPrice_data" :money="modifyPrice_money" @onSubmit="orderLists"></modifyPrice>

        <!-- 支付空驶费组件 -->
        <paymentEmptyFare
            :isShow="paymentEmptyFare_show"
            :data="paymentEmptyFare_data"
            :money="paymentEmptyFare_money"
            @onSubmit="orderLists"
        ></paymentEmptyFare>

        <!-- 订单回访组件 -->
        <visitOrder
            :isShow="visitOrder_show"
            :data="visitOrder_data"
            :status="visitOrder_status"
            @onSubmit="orderLists"
            :city="visitOrder_city"
            :phone="visitOrder_phone"
        ></visitOrder>

        <!-- 协助指派组件 -->
        <transfer
            :isShow="transferOrder_show"
            :city="transferOrder_city"
            :transferOrder_start="transferOrder_start"
            :order_code="transferOrder_code"
            :order_mode_code="transferOrder_mode_code"
            @tipModelShow="tipModelShow"
            @onSubmit="orderLists"
        >
        </transfer>

        <!-- 订单收回组件 -->
        <orderBack :isShow="orderBack_show" :data="orderBack_data" @onSubmit="orderLists"></orderBack>

        <!-- 表格右键菜单栏组件 -->
        <context-button
            v-if="menuVisible"
            @foo="foo"
            ref="contextbutton"
            @salesOrder="salesOrder"
            :transferOrder_city="transferOrder_city"
            @orderPayment="orderPayment"
            @modifyPrice="modifyPrice"
            @paymentEmptyFare="paymentEmptyFare"
            :paymentEmptyFare_money="paymentEmptyFare_money"
            :data="context_data"
            :orderPay="orderPaymentContextmenu_show"
            :modifyPrice="modifyPriceContextmenu_show"
            :orderPayment_money="orderPayment_money"
            :modifyPrice_money="modifyPrice_money"
            @transferOrder="transferOrder"
            @orderBack="orderBack"
            :orderBackMenu_show="orderBackMenu_show"
            :transferOrder_start="transferOrder_start"
            :order_mode_code="transferOrder_mode_code"
            :transferOrderMenu_show="transferOrderMenu_show"
            @toAppend="toAppend"
            :visitOrder_status="visitOrder_status"
            :visitOrder_city="visitOrder_city"
            :visitOrder_phone="visitOrder_phone"
            @visitOrder="visitOrder"
            @editOrder="editOrder"
            @orderAssess="orderAssess"
            @toCoupon="toCoupon"
        >
        </context-button>

        <!-- 追加订单组件 -->
        <append
            :isShow="append_show"
            :data="append_data"
            :city="append_city"
            :transferOrder_start="append_start"
            :order_mode_code="transferOrder_mode_code"
            @tipModelShow="tipModelShow"
            @onSubmit="orderLists"
        >
        </append>

        <tipModel :isShow="tipModel_isShow" :data="tipModel_data" :type_data="tipModel_type"></tipModel>

        <visitHistory :isShow="visitHistory_isShow" :data="visitHistory_data"></visitHistory>

        <editOrder :isShow="editOrder_show" :data="editOrder_data"></editOrder>

        <orderAssess :isShow="orderAssess_show" :data="orderAssess_data"></orderAssess>
    </div>
</template>

<script>
import viewRoute from './viewRoute.vue';
// import toDispatch from './toDispatch.vue';
import salesOrder from './salesOrder.vue';
import orderPayment from './orderPayment.vue';
import modifyPrice from './modifyPrice.vue';
import paymentEmptyFare from './paymentEmptyFare.vue';
import iframeModel from '../../../common/iframe.vue';
import editDriverDrawer from '../../driver/editDriverDrawer.vue';
import editConsumer from '../../user/editConsumer.vue';
import contextButton from './contextButton.vue';
import visitOrder from './visitOrder.vue';
import transfer from './transfer.vue';
import append from './append.vue';
import orderBack from './orderBack.vue';
import tipModel from '../tips.vue';
import visitHistory from './visitHistory.vue';
import editOrder from './editOrder.vue';
import orderAssess from './orderAssess.vue';
import { config } from '@/utils/config.js'; //配置
import selectPages1 from '@/components/mine/selectPages.vue';
import selectPages2 from '@/components/mine/selectPages.vue';
import axios from 'axios'; // AJAX封装类
var _this;
export default {
    components: {
        viewRoute,
        // toDispatch,
        salesOrder,
        iframeModel,
        editDriverDrawer,
        editConsumer,
        orderPayment,
        modifyPrice,
        paymentEmptyFare,
        visitOrder,
        transfer,
        contextButton,
        orderBack,
        tipModel,
        append,
        visitHistory,
        editOrder,
        orderAssess,
        selectPages1,
        selectPages2
    },
    data() {
        return {
            loading: false,

            proName: config.proType,

            nanStyles: {
                color: '#10a4f2'
            },
            nvStyles: {
                color: '#ff66a7'
            },
            excelHead: ['司机姓名', '司机电话', '乘客姓名', '乘客电话', '起点名称'],
            // 导出excel表格数据
            excelData: [],

            platform_select_array: [],
            port_select_array: [],
            vip_select_array: [],

            order_type_select: [],

            consunmerCancelStatusList: [],

            orderAssess_show: false,
            orderAssess_data: '',

            append_show: false,
            append_data: '',
            append_city: '',
            append_start: '',

            btn_loading: false,

            editOrder_show: false,
            editOrder_data: '',

            visitHistory_isShow: false,
            visitHistory_data: '',

            tipModel_isShow: false,
            tipModel_data: '',
            tipModel_type: '',

            menuVisible: false,

            orderBack_show: false,
            orderBack_data: '',

            orderPaymentContextmenu_show: true,
            modifyPriceContextmenu_show: true,
            orderBackMenu_show: true,

            // 右键菜单栏需要的code
            context_data: '',

            transferOrder_show: false,
            transferOrder_city: '',
            transferOrder_start: '',
            transferOrder_mode_code: '',
            transferOrder_code: '',
            transferOrderMenu_show: false,

            visitOrder_show: false,
            visitOrder_data: '',
            visitOrder_status: '',
            visitOrder_city: '',
            visitOrder_phone: '',

            orderPayment_show: false,
            modifyPrice_show: false,
            orderPayment_data: '',
            modifyPrice_data: '',
            orderPayment_money: '',
            modifyPrice_money: '',

            edit_consumer_isShow: false,
            consumer_code_children: '',

            // 传给查看组件的订单状态
            order_status: '',

            // 每种状态的总数
            order_number: '',

            edit_driver_isShow: false,
            driver_code_children: '',

            paymentEmptyFare_show: false,
            paymentEmptyFare_data: '',
            paymentEmptyFare_money: '',

            edit_isShow: false,
            edit_dialog_data: '',

            iframe_show: false,
            iframe_url: '',
            iframe_param: '',

            // 预约自定义时间
            order_time_arrway: [],

            //完成自定义时间
            complete_time_arrway: [],

            is_new_visit_array: [],

            // 查看路线开关
            viewRoute_show: false,

            // 销单开关
            salesOrder_show: false,

            more_query: false,

            order_fixed_time_value: '',

            complete_fixed_time_value: '',

            // 派单组件显示开关
            toDispatch_isShow: false,

            // 派单组件数据
            toDispatch_data: '',

            // 追加组件数据
            append_data: '',

            // 选项卡默认选中项
            activeName: '',

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: [],

            // 下拉搜索模式
            value_mode_code: '',
            options_mode_code: [],
            mode_options_data: {
                page: 1,
                limit: 100,
                status: '1'
            },
            options_group_code: [],
            group_options_data: {
                page: 1,
                limit: 5
            },
            value_coupon_code: '',
            coupon_options_data: {
                page: 1,
                limit: 5
            },
            value_group_code: '',

            delDriverSubmit_rules: {
                driver_code_array: {
                    placeholder: '权限模块',
                    rules: {
                        required: false,
                        message: '权限模块代码数组(json)',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                }
            },

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                billno: '',
                status: '',
                pay_channel: '',
                order_fixed_array: '',
                platform: '',
                complete_fixed_array: '',
                consumer_name: '',
                consumer_phone: '',
                start_name: '',
                driver_phone: '',
                driver_name: '',
                admin_name: '',
                admin_phone: '',
                order_mode_code: '',
                is_new_visit: '',
                visit_status: '',
                consumer_vip: '',
                port: '',
                order_code: '',
                group_wallet_code: '',
                order_source: '',
                coupon_mode_code: '',
                order_consumer_cancel_status: '',
                pay_no: '',
                cancel_status: '',
                order_type: ''
            },

            selectPages_data: [],

            selectPages_group_data: [],
            selectPages_coupon_data: [],
            options_coupon_code: [],

            partnerList: [],

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.iframe_url = config.h5;

        console.log(config.h5, '------------');

        if (_this.$route.query.order_code) {
            _this.search_data.order_code = _this.$route.query.order_code;
        }

        // axios.defaults.baseURL = config.axios_normalURL; //请求normal url
        _this
            .$post('/order/getPartnerList', _this.search_data, _this.search_rules, 'normal')
            .then((res) => {
                _this.partnerList = res.data;
                // axios.defaults.baseURL = config.axios_baseURL; //请求normal url
            })
            .catch((err) => {});
        // axios.defaults.baseURL = config.axios_baseURL; //请求normal url

        //获取空驶费搜索列表
        _this
            .$post('/order/getConsunmerCancelStatusList')
            .then((res) => {
                _this.consunmerCancelStatusList = res.data;
            })
            .catch((err) => {});

        _this.orderLists();
    },

    methods: {
        selectPages_coupon_function(search_data) {
            _this.coupon_options_data.page = search_data;

            _this.couponList();
        },
        couponList() {
            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    _this.selectPages_coupon_data = res;
                    _this.options_coupon_code = res.data;
                })
                .catch((err) => {});
        },
        couponChange(val) {
            _this.search_data.coupon_mode_code = val;
            // 解决翻页选项显示编码问题
            for (let i = 0; i < _this.options_coupon_code.length; i++) {
                if (val == _this.options_coupon_code[i].coupon_mode_code) {
                    _this.value_coupon_code = _this.options_coupon_code[i].name;
                }
            }
        },

        toCoupon(code) {
            this.$router.push({
                path: 'couponRecordLists',
                query: {
                    order_code: code
                }
            });
        },
        orderAssess(code) {
            _this.orderAssess_show = !_this.orderAssess_show;
            _this.orderAssess_data = code;
        },
        //订单修改
        editOrder(code) {
            _this.editOrder_show = !_this.editOrder_show;
            _this.editOrder_data = code;
        },

        tipModelShow(msg) {
            _this.tipModel_isShow = !_this.tipModel_isShow;
            _this.tipModel_data = msg;
            _this.tipModel_type = 'success';
        },

        orderBack(code, status) {
            _this.orderBack_show = !_this.orderBack_show;
            _this.orderBack_data = code;
        },

        // 表格右键点击事件
        rowContextmenu(row, column, event) {
            if (row.status.val == '7' || row.status.val == '8' || row.status.val == '9') {
                _this.orderPaymentContextmenu_show = true;
            } else {
                _this.orderPaymentContextmenu_show = false;
            }
            if (row.status.val == '8') {
                _this.modifyPriceContextmenu_show = true;
            } else {
                _this.modifyPriceContextmenu_show = false;
            }

            if (row.status.val == '2' || row.status.val == '3' || row.status.val == '4' || row.status.val == '5' || row.status.val == '6') {
                _this.orderBackMenu_show = true;
            } else {
                _this.orderBackMenu_show = false;
            }

            if (row.status.val == '14' || row.status.val == '0') {
                _this.transferOrderMenu_show = true;
                _this.transferOrder_mode_code = row.order_mode.order_mode_code;
            } else {
                _this.transferOrderMenu_show = false;
            }

            _this.visitOrder_status = row.visit_status.val;
            _this.visitOrder_phone = row.consumer_phone;

            _this.orderPayment_money = row.amount;
            _this.modifyPrice_money = row.amount;

            _this.context_data = row.order_code;
            _this.transferOrder_start = row.start_coordinate;

            if (this.menuVisible) {
                this.menuVisible = false;

                setTimeout(() => {
                    this.menuVisible = true;

                    this.$nextTick(() => {
                        this.$refs.contextbutton.init(row, column, event);
                    });
                }, 1);
            } else {
                this.menuVisible = true;

                this.$nextTick(() => {
                    this.$refs.contextbutton.init(row, column, event);
                });
            }

            // 阻止右键默认行为
            event.preventDefault();
        },

        foo() {
            // 取消鼠标监听事件 菜单栏
            this.menuVisible = false;
            document.removeEventListener('click', this.foo);
        },

        transferOrder(code, city, start_coordinate, order_mode_code) {
            _this.transferOrder_show = !_this.transferOrder_show;

            _this.transferOrder_code = code;
            _this.transferOrder_mode_code = order_mode_code;
            _this.transferOrder_city = city;
            _this.transferOrder_start = start_coordinate;
        },

        visitOrder(code, visit_status, phone) {
            _this.visitOrder_show = !_this.visitOrder_show;
            _this.visitOrder_data = code;
            _this.visitOrder_status = visit_status;
            _this.visitOrder_city = city;
            _this.visitOrder_phone = phone;
        },
        paymentEmptyFare(code, money) {
            _this.paymentEmptyFare_show = !_this.paymentEmptyFare_show;
            _this.paymentEmptyFare_data = code;
            _this.paymentEmptyFare_money = money;
        },

        orderPayment(code, money) {
            _this.orderPayment_show = !_this.orderPayment_show;
            _this.orderPayment_data = code;
            _this.orderPayment_money = money;
        },
        modifyPrice(code, money) {
            _this.modifyPrice_show = !_this.modifyPrice_show;
            _this.modifyPrice_data = code;
            _this.modifyPrice_money = money;
        },

        toDriver(code) {
            _this.driver_code_children = code;
            _this.edit_driver_isShow = !_this.edit_driver_isShow;
        },

        toConsumer(code) {
            _this.consumer_code_children = code;
            _this.edit_consumer_isShow = !_this.edit_consumer_isShow;
        },

        toCity(code) {
            _this.edit_dialog_data = code;
            _this.edit_isShow = !_this.edit_isShow;
        },

        toIframe(code) {
            _this.iframe_param = code;
            _this.iframe_show = true;

            console.log(this.iframe_url);
        },

        searchOrderLists() {
            if (
                (_this.search_data.status == 'serving' && _this.search_data.complete_fixed_array.length != 0) ||
                (_this.search_data.status == 'proceed' && _this.search_data.complete_fixed_array.length != 0) ||
                (_this.search_data.status == 'new' && _this.search_data.complete_fixed_array.length != 0)
            ) {
                _this.$message.error('当前状态无完成时间数据,不能进行搜索');

                return;
            }

            _this.search_data.page = 1;
            _this.orderLists();
        },

        // 销单按钮
        salesOrder(code) {
            _this.salesOrder_show = !_this.salesOrder_show;

            _this.toDispatch_data = code;
        },

        // 重置按钮
        refresh() {
            _this.search_data = {
                page: 1,
                limit: 10,
                billno: '',
                status: '',
                pay_channel: '',
                order_fixed_array: '',
                platform: '',
                complete_fixed_array: '',
                consumer_name: '',
                consumer_phone: '',
                start_name: '',
                driver_phone: '',
                driver_name: '',
                admin_name: '',
                admin_phone: '',
                order_mode_code: '',
                is_new_visit: '',
                visit_status: '',
                consumer_vip: '',
                port: '',
                order_code: '',
                group_wallet_code: '',
                order_source: '',
                coupon_mode_code: '',
                order_consumer_cancel_status: '',
                pay_no: '',
                cancel_status: '',
                order_type: ''
            };

            _this.order_time_arrway = [];
            _this.complete_time_arrway = [];
            _this.order_fixed_time_value = '';
            _this.complete_fixed_time_value = '';
        },

        // 搜索时间选择触发
        timeChange(parm) {
            if (parm == 'order') {
                _this.search_data.complete_fixed_array = '';
                if (_this.order_time_arrway == null) {
                    _this.search_data.order_fixed_array = '';
                    return;
                }
                _this.search_data.order_fixed_array = JSON.stringify(['between'].concat(_this.order_time_arrway));
            } else if (parm == 'complete') {
                _this.search_data.order_fixed_array = '';
                if (_this.complete_time_arrway == null) {
                    _this.search_data.complete_fixed_array = '';
                    return;
                }
                _this.search_data.complete_fixed_array = JSON.stringify(['between'].concat(_this.complete_time_arrway));
            }
        },

        // 搜索预约时间触发
        orderFixedTimeChange(val) {
            _this.order_time_arrway = [];

            _this.search_data.order_fixed_array = [];
            if (val == 'between') {
                _this.search_data.order_fixed_array.push(_this.order_fixed_time_value);
            } else if (val == '') {
            } else {
                _this.search_data.order_fixed_array.push(_this.order_fixed_time_value);

                _this.search_data.order_fixed_array = JSON.stringify(_this.search_data.order_fixed_array);
            }
        },

        // 搜索完成时间触发
        completeFixedTimeChange(val) {
            _this.complete_time_arrway = [];

            _this.search_data.complete_fixed_array = [];
            if (val == 'between') {
                _this.search_data.complete_fixed_array.push(_this.complete_fixed_time_value);
            } else if (val == '') {
            } else {
                _this.search_data.complete_fixed_array.push(_this.complete_fixed_time_value);

                _this.search_data.complete_fixed_array = JSON.stringify(_this.search_data.complete_fixed_array);
            }
        },

        // 查看按钮方法
        orderViewRoute(code, status) {
            _this.viewRoute_show = !_this.viewRoute_show;

            _this.toDispatch_data = code;

            _this.order_status = status;
            console.log(_this.order_status, '_this.order_status============---------------');
        },

        toAppend(code, city, start_coordinate, order_mode_code) {
            _this.append_show = !_this.append_show;
            _this.append_data = code;
            _this.append_city = city;
            _this.append_start = start_coordinate;
            _this.transferOrder_mode_code = order_mode_code;
        },

        modeChange(val) {
            _this.search_data.order_mode_code = val;
            // 解决翻页后，订单模式显示编码问题
            for (let i = 0; i < _this.options_mode_code.length; i++) {
                if (val == _this.options_mode_code[i].order_mode.order_mode_code) {
                    _this.value_mode_code = _this.options_mode_code[i].order_mode.name;
                }
            }
        },
        groupChange(val) {
            _this.search_data.group_wallet_code = val;
            // 解决翻页选项显示编码问题
            for (let i = 0; i < _this.options_group_code.length; i++) {
                if (val == _this.options_group_code[i].group_wallet_code) {
                    _this.value_group_code = _this.options_group_code[i].group_name;
                }
            }
        },

        selectPages_function(val) {
            _this.mode_options_data.page = val;
            console.log(_this.mode_options_data);
            _this.orderModeList();
        },

        selectPages_group_function(search_data) {
            _this.group_options_data.page = search_data;

            _this.groupList();
        },

        orderModeList() {
            _this.loading = true;
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {
                    _this.loading = false;
                    _this.selectPages_data = res;
                    _this.options_mode_code = res.data;
                    console.log(_this.options_mode_code, '_this.options_mode_code=--');
                })
                .catch((err) => {});
        },

        groupList() {
            _this
                .$post('/group/groupWalletLists', _this.group_options_data)
                .then((res) => {
                    _this.selectPages_group_data = res;
                    _this.options_group_code = res.data;
                })
                .catch((err) => {});
        },

        //搜索的下拉框弹出触发
        modeVisibleChange(val) {
            _this.orderModeList();
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            console.log(tab.name, 'tab.name');
            _this.search_data.status = tab.name;

            _this.search_data.page = 1;

            _this.search_data.cancel_status = '';

            _this.orderLists();
        },

        getOrderCount() {
            _this.btn_loading = true;
            // 获取每个状态的总数
            _this
                .$post('/order/getOrderCount', {
                    order_fixed_array: _this.search_data.order_fixed_array,
                    complete_fixed_array: _this.search_data.complete_fixed_array,
                    consumer_phone: _this.search_data.consumer_phone,
                    driver_phone: _this.search_data.driver_phone,
                    type: '1'
                })
                .then((res) => {
                    _this.order_number = res.data;
                    _this.btn_loading = false;
                })
                .catch((err) => {});
        },

        // 搜索订单列表
        orderLists() {
            _this.tableData = [];

            _this
                .$post('/order/orderLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    _this.platform_select_array = res.data[0].platform.select_array;
                    _this.port_select_array = res.data[0].port.select_array;
                    _this.vip_select_array = res.data[0].consumer_vip.select_array;
                    _this.is_new_visit_array = res.data[0].is_new_visit.select_array;

                    _this.order_type_select = res.data[0].order_type.select_array;

                    // console.log(_this.tableData[0].platform);
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.orderLists();
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}

.table-head {
    margin-bottom: 20px;
}

.table-head > div {
    width: 25%;
}

.table-head > div .title {
    display: block;
    width: 100px;
    padding-right: 16px;
    text-align: right;
    box-sizing: border-box;
    color: #606266;
    height: 28px;
    line-height: 28px;
    float: left;
}

.table-head-search {
    display: flex;
    justify-content: space-between;
}

.table-head .search-radio {
    width: 100%;
}

.container-tabs .el-tabs__item.is-top.is-active {
    border: 1px solid #dcdfe6;
}

.vip {
    color: goldenrod;
}
.groupName {
    color: green !important;
}
</style>


<style>
.fs-big .el-radio__label {
    font-size: 14px !important;
    font-weight: 500;
    color: #000;
}

.table-head-search .el-select.el-select--small,
.table-head .el-radio-group {
    width: calc(100% - 100px);
}

.table-head-search .el-select.el-select--small .el-input.el-input--small.el-input--suffix {
    width: 100% !important;
}

.table-head > div .el-input--small {
    width: calc(100% - 100px);

    float: left;
}

.table-head > div .el-input--small .el-input__inner {
    height: 28px;
    line-height: 28px;
}

.container .el-tabs__header {
    margin-bottom: 0 !important;
}

.table-head .el-checkbox__inner {
    display: none;
}

.table-head .el-radio__inner {
    display: none;
}

.table-head .el-checkbox-group {
    display: inline-block;
}

.table-head .el-checkbox,
.table-head .el-radio {
    border: 0px solid transparent;
    background-color: transparent;
    border-radius: 5px !important;
}

.table-head .el-checkbox.is-checked,
.table-head .el-radio.is-checked {
    border: 0px solid #409eff;
    /* background-color: #ecf5ff;  */
}

.table-head .el-checkbox__label,
.table-head .el-radio__label {
    padding: 0;
}

.container-tabs .el-tabs__nav.is-top {
    border: 0;
}

.container-tabs .el-tabs__item.is-top {
    border: 1px solid transparent;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.container-tabs .el-tabs__header.is-top {
    border-bottom: 0;
}

.el-col.el-col-6 > span {
    display: inline-block;
    width: 100px;
    text-align: left;
}

.sub #tab-new .table-title {
    color: #65c138;
}

.sub #tab-proceed .table-title {
    color: #b6ae3a;
}

.sub #tab-serving .table-title {
    color: #409eff;
}

.sub #tab-unpaid .table-title {
    color: #f67745;
}

.sub #tab-paid .table-title {
    color: #606266;
}

.sub #tab-order_cancel .table-title {
    color: #606266;
}

.order-table-lists .el-table__body .cell {
    color: #000;
    font-weight: 500;
    font-size: 18px;
}

.el-date-range-picker__time-header {
    display: block;
}
.img-wrap {
    display: flex;
    align-items: center;
}
.sexImg {
    display: block;
    width: 14px;
    height: 14px;
}
</style>
